import { isWorker } from '../utils/utils';
import { IWidgetControllerConfig } from '@wix/native-components-infra/dist/src/types/types';
import {
  DEDAULT_TINY_CART_CONFIG,
  EcomPlatformWidgetID,
  MINICART_POPUP_URL,
} from '../constants';
import { EcomPlatformViewerScriptContext, TinyCartParams } from './types';

export function shouldOpenMiniCart(context: EcomPlatformViewerScriptContext) {
  const cartExists = context.siteStore.isCartExists;
  const isViewer =
    context.siteStore.isSiteMode() || context.siteStore.isPreviewMode();
  const isLightbox = !!context.siteStore.windowApis.lightbox.getContext();
  return (
    !context.siteStore.isMobile() &&
    isViewer &&
    isWorker() &&
    cartExists &&
    !isLightbox
  );
}

export function getTinyCartParams(
  config: IWidgetControllerConfig[],
): TinyCartParams {
  let popupUrl = MINICART_POPUP_URL;

  const cartIconConf = config.filter(
    (c) => c.type === EcomPlatformWidgetID.CART_ICON,
  );

  if (cartIconConf.length && cartIconConf[0].config.externalId) {
    popupUrl += `?externalId=${cartIconConf[0].config.externalId}`;
  }

  const cartIconConfig = cartIconConf[0];
  const cartIconCompId = cartIconConfig?.compId;
  const fallbackCompId = config[0]?.compId;
  const miniCartCompId =
    (cartIconConf.length > 0 && cartIconCompId) || fallbackCompId;

  return [popupUrl, DEDAULT_TINY_CART_CONFIG, miniCartCompId];
}
